import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const TurkeyFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16070'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16070)'>
				<rect
					width='20'
					height='14'
					fill='#E92434'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M13.5855 7.53786L12.7106 8.57735L12.7702 7.23116L11.491 6.73697L12.8159 6.37652L12.9002 5.03161L13.6594 6.15502L14.9907 5.81801L14.135 6.87277L14.8735 8.0094L13.5855 7.53786Z'
					fill='white'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M12.4304 9.57893C11.6461 10.5655 10.4224 11.2 9.04743 11.2C6.6805 11.2 4.76172 9.31965 4.76172 7.00005C4.76172 4.68045 6.6805 2.80005 9.04743 2.80005C10.4224 2.80005 11.6461 3.43459 12.4304 4.42117C11.8252 3.99013 11.0643 3.73338 10.2379 3.73338C8.26546 3.73338 6.66648 5.19592 6.66648 7.00005C6.66648 8.80418 8.26546 10.2667 10.2379 10.2667C11.0643 10.2667 11.8252 10.01 12.4304 9.57893Z'
					fill='white'
				/>
			</g>
		</svg>
	);
};

export default TurkeyFlagIcon;
